import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { UserPlus, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaSolicitanteAtribuido = (acao: string): boolean => {
    const acaoLower = acao.toLowerCase().trim();
    return acaoLower.includes('atribuiu escritório solicitante') || acaoLower.includes('alterou escritório solicitante');
};

const getIconSolicitanteAtribuido = (acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: UserPlus, color: 'var(--c8041c7)' };
};

export default function CardSolicitanteAtribuido({ item, onNavigateToFile, isExpanded, onToggleExpand }: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconSolicitanteAtribuido(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={<ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />}
        />
    );
}

export const solicitanteAtribuidoConfig = {
    tipo: 'solicitante_atribuido',
    detectaTipo: detectaSolicitanteAtribuido,
    getIcon: getIconSolicitanteAtribuido,
    temExpansao: () => true,
    Component: CardSolicitanteAtribuido
};

